/**
 * ชั้นแปลงชื่อฟิลด์ — snake_case (ที่ backend ส่งมา) → camelCase (ที่หน้าจอใช้)
 *
 * ทั้งโปรเจกต์แปลงที่นี่ **ที่เดียว** ตามกติกาใน API-REQUIREMENTS.md
 * ("รูปแบบชื่อฟิลด์ snake_case ฝั่งแอปแปลงเป็น camelCase ให้เองที่ชั้นเดียว")
 *
 * เหตุผลที่ต้องมีชั้นนี้: เมื่อ backend พร้อม เราสลับจาก mock ไป API จริงได้
 * โดยไม่ต้องแตะไฟล์หน้าจอแม้แต่บรรทัดเดียว
 */

type Json = string | number | boolean | null | Json[] | { [k: string]: Json };

const toCamel = (s: string): string => s.replace(/_([a-z0-9])/g, (_, c: string) => c.toUpperCase());
const toSnake = (s: string): string => s.replace(/[A-Z]/g, (c) => '_' + c.toLowerCase());

function mapKeys(value: unknown, fn: (k: string) => string): unknown {
  if (Array.isArray(value)) return value.map((v) => mapKeys(v, fn));
  if (value === null || typeof value !== 'object') return value;
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
    out[fn(k)] = mapKeys(v, fn);
  }
  return out;
}

/** ใช้กับทุก response ที่ได้จาก backend */
export function camelize<T>(input: Json | unknown): T {
  return mapKeys(input, toCamel) as T;
}

/** ใช้กับทุก request body ที่ส่งไป backend */
export function snakeize(input: unknown): unknown {
  return mapKeys(input, toSnake);
}
